// extracted by mini-css-extract-plugin
export default {"container":"AbilityClick_container__zgqWV","cooldownCircle":"AbilityClick_cooldownCircle__bGzcD"};